const certificatesUrl = 'certificates/';

export default { certificatesUrl };
